import React, { ChangeEvent, useEffect, useState } from "react";
import "./check-box.scss";

interface CheckBoxProps {
  label: string;
  defaultValue?: boolean;
  isDisabled?: boolean;
  id: string;
  onCheckBoxValueChange: (data: { name: string; value: boolean }) => void;
}

export function CheckBox(props: CheckBoxProps) {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (props.defaultValue) {
      setIsChecked(props.defaultValue);
    }
  }, [props?.defaultValue]);

  function handleCheckboxChange(event: ChangeEvent<HTMLInputElement>): void {
    const dataToEmit = { name: props.id, value: event.target.checked };
    setIsChecked(event.target.checked);
    props.onCheckBoxValueChange(dataToEmit);
  }

  return (
    <>
      <div className="custom-checkbox-container">
        <input
          type="checkbox"
          id={props.id}
          name={props.id}
          value={props.id}
          checked={isChecked}
          onChange={handleCheckboxChange}
          disabled={props.isDisabled}
        />
        <label htmlFor={props.id}>{props.label}</label>
      </div>
    </>
  );
}
